module.exports = __webpack_public_path__ + "img/transfer-image.621c4773.png";